import React, { Suspense } from "react";
import MomentUtils from "@date-io/moment";
import { ThemeProvider, CssBaseline, LinearProgress } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    bootstrapApplication,
    ErrorBoundary,
    defaultDateTimeFormat,
    defaultDateFormat,
    defaultTimeFormat,
} from "../Shared";
import { theme } from "./theme";
import { ProfileSuspender } from "./ProfileSuspender";

type OwnProps = Record<string, any>;

class LocalizedUtils extends MomentUtils {
    dateFormat = defaultDateFormat;

    dateTime12hFormat = defaultDateTimeFormat;
    dateTime24hFormat = defaultDateTimeFormat;

    time12hFormat = defaultTimeFormat;
    time24hFormat = defaultTimeFormat;
}

const InnerReactContainer: <P extends OwnProps>(
    WrappedComponent: React.ComponentType<P>,
    // eslint-disable-next-line react/display-name
) => React.ComponentType<Omit<P, keyof OwnProps>> =
    <P extends OwnProps>(WrappedComponent: React.ComponentType<P>) =>
    (props: P) => {
        const { locale, moment } = bootstrapApplication();

        return (
            <React.StrictMode>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <ErrorBoundary>
                        <Suspense fallback={<LinearProgress />}>
                            <ProfileSuspender>
                                <MuiPickersUtilsProvider utils={LocalizedUtils} libInstance={moment} locale={locale}>
                                    <WrappedComponent {...props} />
                                </MuiPickersUtilsProvider>
                            </ProfileSuspender>
                        </Suspense>
                    </ErrorBoundary>
                </ThemeProvider>
            </React.StrictMode>
        );
    };

/**
 * Irisity ReactContainer sets up and bootstraps React inside Angular application, including theme and suspense for tranlations async loading handling
 * Main idea is that once Manage portal is migrated to react (layout/menu), this component can be removed
 */
export const ReactContainer = <P extends OwnProps>(component: React.ComponentType<P>) => {
    return InnerReactContainer(component);
};
